import { ArrowRight, Phone } from "lucide-react";
import { BUSINESS } from "@/lib/config";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Hero() {
  return (
    <section
      className="relative isolate overflow-hidden border-b border-zinc-800"
      data-testid="hero-section"
    >
      {/* Background image with heavy overlay */}
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1508465818649-14a170138405?auto=format&fit=crop&w=2400&q=80"
          alt="Industrial welding sparks"
          className="h-full w-full object-cover opacity-40"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-950/60 via-zinc-950/85 to-zinc-950" />
      </div>

      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 pt-20 pb-24 lg:pt-28 lg:pb-32">
        <div>
          <div
            className="mb-6 inline-flex items-center gap-3 border border-zinc-700 bg-zinc-900/70 px-3 py-1.5"
            data-testid="hero-location-tag"
          >
            <span className="h-1.5 w-1.5 bg-orange-500" />
            <span className="font-mono-spec text-zinc-200">
              {BUSINESS.location} · {BUSINESS.responseTime}
            </span>
          </div>

          <h1
            className="font-display text-6xl text-white sm:text-7xl lg:text-[7.5rem]"
            data-testid="hero-headline"
          >
            Laser Cutting
            <br />
            <span className="text-orange-500">& Engraving</span>
            <br />
            <span className="text-zinc-300">Done Right.</span>
          </h1>

          <p
            className="mt-8 max-w-2xl text-lg text-zinc-300 sm:text-xl"
            data-testid="hero-subhead"
          >
            Precision laser work for small manufacturers, product companies, and
            shops that need parts <strong className="text-white">fast</strong> — from
            one-off prototypes to full production runs. Steel, aluminum, wood,
            acrylic, leather and more.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
            <button
              onClick={() => scrollToId("book")}
              className="shadow-brutal group inline-flex h-16 items-center justify-center gap-3 border-2 border-orange-600 bg-orange-600 px-8 font-display text-2xl uppercase tracking-wider text-white"
              data-testid="hero-book-call-btn"
            >
              Book a Call
              <ArrowRight className="h-6 w-6 transition-transform duration-150 group-hover:translate-x-1" />
            </button>

            <a
              href={BUSINESS.phoneTel}
              className="inline-flex h-16 items-center justify-center gap-3 border-2 border-zinc-700 bg-transparent px-8 font-display text-xl uppercase tracking-wider text-white transition-colors duration-100 hover:border-white hover:bg-white hover:text-zinc-950"
              data-testid="hero-call-now-link"
            >
              <Phone className="h-5 w-5" />
              Call Now
            </a>
          </div>

          <p
            className="mt-6 font-mono-spec text-zinc-500"
            data-testid="hero-no-pitch-line"
          >
            Send your file, get a quote, get parts.
          </p>
        </div>
      </div>
    </section>
  );
}
